// extracted by mini-css-extract-plugin
export var details = "_hi-0";
export var inspectorPopover = "_hi-1";